import { Theme } from "@astryxdesign/core";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { hireosTheme } from "@shared/theme/hireos";

// Fonts are self-hosted via @font-face in public/fonts.css (#117), linked
// by build.ts — a @fontsource import base64-inlines the woff2 into the
// CSS bundle.
import "./styles.css";
import { initAnalytics } from "./lib/analytics";
import { AuthProvider } from "./lib/auth";
import { router } from "./router";
import { ToastLayer } from "./components/ui/Toast";

initAnalytics();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <Theme theme={hireosTheme} mode="light">
      <ToastLayer>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastLayer>
    </Theme>
  </StrictMode>,
);
